// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table{border-collapse:collapse;margin:1.2em 0;table-layout:fixed;text-align:left;width:100%}thead{line-height:1.3;vertical-align:bottom}tbody{vertical-align:top}tr{border-bottom:1px solid #ddd}th{font-weight:600}td,th{padding:.6em .6em .6em 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
